export default {
	setHeader(state, data) {
		state.header = data;
		axios.defaults.headers[data.name] = data.value;
	},
	setListOfStatuses(state, data) {
		state.listOfStatuses = data;
	},
	setLoad(state, data) {
		state.load = data;
	},
	setHref(state, data) {
		state.href = data;
	},
	routePush(state, oprions) {
		// window.history.pushState(oprions.state, oprions.title, oprions.url);
		state.href = oprions.url;
	},
	setMessage(state, data) {
		state.message = data;
	},
};
